export const getBonusSummary = (state) => {
  return state.bonusSummary;
};

export const getDistrictId = (state) => {
  const { district } = getBonusSummary(state);
  return (district) ? district.id : null;
};

export const getDepartmentId = (state) => {
  const { department } = getBonusSummary(state);
  return (department) ? department.id : null;
};

export const getBonusMonth = (state) => {
  const { bonusMonth } = getBonusSummary(state);
  return bonusMonth;
};

export const getMonthBonusState = (state) => {
  const { monthBonusState } = getBonusSummary(state);
  return monthBonusState;
};

export const getDepartmentName = (state) => {
  const { department } = getBonusSummary(state);
  return (department) ? department.name : null;
};

export const getDistrictName = (state) => {
  const { district } = getBonusSummary(state);
  return (district) ? district.name : null;
};

export const getDepartment = (state) => {
  const { department } = getBonusSummary(state);
  return department;
};

export const getDistrict = (state) => {
  const { district } = getBonusSummary(state);
  return district;
};
